import { render, staticRenderFns } from "./addProductDialog.vue?vue&type=template&id=0ecdf3d0&scoped=true&"
import script from "./addProductDialog.vue?vue&type=script&lang=js&"
export * from "./addProductDialog.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialog.vue?vue&type=style&index=0&id=0ecdf3d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecdf3d0",
  null
  
)

export default component.exports